import { BoardEditor, FullModal, IBoard, Spacer } from '@vestaboard/installables'
import React, { useEffect, useState } from 'react'

interface IMessageCreator {
  visible: boolean
  setVisible: (visible: boolean) => void
  onSave: (message: IBoard) => void
  defaultValue?: IBoard | null
  isNote?: boolean
}

export const MessageCreator = (props: IMessageCreator) => {
  const [value, setValue] = useState(
    props?.isNote ? Array(3).fill(Array(15).fill(0)) : Array(6).fill(Array(22).fill(0))
  )

  useEffect(() => {
    if (props?.defaultValue) {
      setValue(props.defaultValue)
    }
  }, [props])

  return props.visible ? (
    <FullModal onClose={() => props.setVisible(false)}>
      <>
        <BoardEditor
          key={props?.isNote ? 'note-editor' : 'standard-editor'}
          boardStyle={props?.isNote ? 'note-black' : 'black'}
          boardValue={value}
          setBoardValue={setValue}
          sendButtonLabel='Save'
          onSend={() => {
            props.setVisible(false)
            props.onSave(value)
          }}
          showFilledColor
        />
        <Spacer size='extraLarge' />
      </>
    </FullModal>
  ) : null
}
